import { render, staticRenderFns } from "./ConvenioAditivos.vue?vue&type=template&id=83a6e96a"
import script from "./ConvenioAditivos.vue?vue&type=script&lang=js"
export * from "./ConvenioAditivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports